
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";   
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import GreyBoxForm  from "@/components/utils/PopulateForms/components/GreyBoxForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType, otherPartyInfoType, noticeSurveyDataInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType, childrenInfoSurveyInfoType } from '@/types/Application/CommonInformation/Pdf';
import { priorityParentingInformationDataInfoType, priorityParentingOtherPartyDataInfoType } from '@/types/Application/PriorityParentingMatter/PDF';
import { priorityParentingMatterOrderSurveyDataInfoType, ppmBackgroundDataSurveyDataInfoType, aboutPriorityParentingMatterOrderSurveyDataInfoType } from '@/types/Application/PriorityParentingMatter';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';

@Component({
    components:{
        UnderlineForm,
        GreyBoxForm,
        CheckBox        
    }
})

export default class Form15Layout extends Vue {

    @Prop({required:true})
    result!: any;    
    
    @applicationState.State
    public applicantName!: nameInfoType;    
    
    dataReady = false;   
    
    otherPartyInfo: priorityParentingOtherPartyDataInfoType[] = [];
    additionalOtherParties: priorityParentingOtherPartyDataInfoType[] = [];
    firstOtherParty = {} as priorityParentingOtherPartyDataInfoType;
    yourInfo = {} as yourInformationInfoDataInfoType;
    ppmInfo = {} as priorityParentingInformationDataInfoType;
    
    existingFileNumber = '';
    filingLocationReason = '';
    fmepNumber = '';
    
    childrenInfo: childrenInfoSurveyInfoType[] = [];

    childrenFields = [
        {key:"fullName",               label:"Child's full name",                          tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:30%;"},
        {key:"dob",                    label:"Child's date of birth (mmm/dd/yyyy)",        tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},
        {key:"myRelationship",         label:"My relationship to the child",               tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:15%;"},        
        {key:"otherPartyRelationship", label:"The other party's relationship to the child",tdClass:"border-dark text-center align-middle", thClass:"border-dark text-center align-middle", thStyle:"font-size:8pt; width:21%;"}
    ]   

    mounted(){
        this.dataReady = false;
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){
               
        this.otherPartyInfo=this.getOtherPartyInfo()        
        this.firstOtherParty = this.otherPartyInfo[0];
        if (this.otherPartyInfo?.length > 1) {
            this.otherPartyInfo.splice(0,1)
            this.additionalOtherParties = this.otherPartyInfo;
        }

        if (this.result.ppmChildrenInfoSurvey?.length > 0){          
            this.childrenInfo = this.getChildrenInfo();
        }
        
        this.yourInfo = this.getYourInfo();
        this.ppmInfo = this.getPpmInfo();
        this.existingFileNumber = getLocationInfo(this.result.filingLocationSurvey);
        this.fmepNumber = this.getFmepInfo(this.result.filingLocationSurvey);      

        if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'y') {
            this.filingLocationReason = 'It is the court location where my existing case with the same party/parties is filed';
        } else if (this.result.filingLocationSurvey?.ExistingFamilyCase == 'n' && this.result.filingLocationSurvey?.filingLocationReason){
            this.filingLocationReason = this.result.filingLocationSurvey.filingLocationReason;
        }
    }     
    
    public getFmepInfo(locationData){
        return locationData?.ExistingFMEPCase  && locationData?.ExistingFMEPCase =='y' && locationData.ExistingFMEPNumber? locationData.ExistingFMEPNumber:'';        
    }
    
    public getChildrenInfo() {

        const childrenInfo: childrenInfoSurveyInfoType[] = [];
        let childInfo = {} as childrenInfoSurveyInfoType;
        const childData = this.result.ppmChildrenInfoSurvey;
       
        for (const child of childData) {            
            childInfo = {fullName: '', dob:'', myRelationship: '', otherPartyRelationship: '', currentSituation: ''};
            childInfo.fullName = Vue.filter('getFullName')(child.name);
            childInfo.dob = Vue.filter('beautify-date-mid')(child.dob);
            childInfo.myRelationship = child.relation;
            childInfo.otherPartyRelationship = child.opRelation;
            childrenInfo.push(childInfo)
        }        

        return childrenInfo;
    }

    public getYourInfo(){           

        if(this.result?.yourInformationSurvey){
            return getYourInformationResults(this.result?.yourInformationSurvey); 
        } 
        else
            return {} as yourInformationInfoDataInfoType
    }

    public getOtherPartyInfo(){

        let OpInformation: priorityParentingOtherPartyDataInfoType[] = [];        

        if (this.result.otherPartyCommonSurvey?.length > 0){
            OpInformation = [];
            const otherPartyData: otherPartyInfoType[] =  this.result.otherPartyCommonSurvey;
           
            for(const party of otherPartyData){ 
                const otherParty = {} as priorityParentingOtherPartyDataInfoType;               

                if (party.knowDob == 'y' &&  party.dob)
                    otherParty.dob = party.dob

                if (party.name)
                    otherParty.name = party.name;
                
                if (party.address)
                    otherParty.address = party.address;
                
                if (party.contactInfo)
                    otherParty.contactInfo = party.contactInfo;
                
                if (party.lawyer)
                    otherParty.lawyer = party.lawyer
                
                OpInformation.push(otherParty)
            }
        } 

        return OpInformation
    }  
    
    public getPpmInfo() {

        const ppmInformation = {} as priorityParentingInformationDataInfoType;

        if (this.result.ppmBackgroundSurvey) {
            const ppmBackgroundData: ppmBackgroundDataSurveyDataInfoType = this.result.ppmBackgroundSurvey;
            ppmInformation.ExistingCase = (ppmBackgroundData.ExistingOrdersFLM == 'y');
            ppmInformation.existingProceeding = (ppmBackgroundData.existingCourtProceeding == 'y');
            ppmInformation.proceedingInfo = (ppmBackgroundData.existingCourtProceeding == 'y' && 
                                             ppmBackgroundData.existingCourtProceedingDetails)? ppmBackgroundData.existingCourtProceedingDetails:'';
        }

        if (this.result.aboutPriorityParentingMatterOrderSurvey) {
            const aboutPpmOrderData: aboutPriorityParentingMatterOrderSurveyDataInfoType = this.result.aboutPriorityParentingMatterOrderSurvey;
            ppmInformation.facts = aboutPpmOrderData.applicationFacts;
            ppmInformation.orderdesc = aboutPpmOrderData.orderDescription;
        }

        if (this.result.noticeSurvey) {
            const noticeData: noticeSurveyDataInfoType = this.result.noticeSurvey;
            ppmInformation.noticeType = noticeData.noticeType;
        }

        if(this.result.ppmQuestionnaireSurvey && this.result.priorityParentingMatterOrderSurvey) {
            const ppmType: string[] = this.result.ppmQuestionnaireSurvey;
            const ppmOrderData: priorityParentingMatterOrderSurveyDataInfoType = this.result.priorityParentingMatterOrderSurvey;
            ppmInformation.ppmList = [];
                 
            if ((ppmType.includes('medical')) && (ppmOrderData.delayMedicalRisk == 'y') && 
                (ppmOrderData.confirmMedicalRisk?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('medical');
                }
            if ((ppmType.includes('passport')) && (ppmOrderData.delayPassportRisk == 'y') && 
                (ppmOrderData.confirmDelayPassportRisk?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('passport');
                }
            if ((ppmType.includes('travel')) && (ppmOrderData.delayTravelRisk == 'y') && 
                (ppmOrderData.travelWrongfullyDenied == 'y') && 
                (ppmOrderData.confirmTravelWrongfullyDenied?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('travel');
                }
            if ((ppmType.includes('locationChange')) && (ppmOrderData.existingParentingArrangements == 'n') &&
                (ppmOrderData.impactOnRelationship == 'y') && 
                (ppmOrderData.confirmImpactOnRelationship?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('locationChange');   
                }
            if ((ppmType.includes('preventRemoval')) && (ppmOrderData.noReturnRisk == 'y') && 
                (ppmOrderData.confirmNoReturnRisk?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('preventRemoval');   
                }
            if ((ppmType.includes('interjurisdictional')) && (ppmOrderData.childInBC == 'y') && 
                (ppmOrderData.harm == 'y') && (ppmOrderData.confirmHarm?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('interjurisdictional');      
                }
            if ((ppmType.includes('wrongfulRemoval')) && (ppmOrderData.wrongfulInBC == 'y') && 
                (ppmOrderData.confirmWrongfulInBC?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('wrongfulRemoval');   
                }
            if ((ppmType.includes('returnOfChild')) && (ppmOrderData.wrongfulReturn == 'y') && 
                (ppmOrderData.confirmWrongfulReturn?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('returnOfChild');
                }
            if ((ppmType.includes('childServices')) && (ppmOrderData.childRemoved == 'y') && 
                (ppmOrderData.confirmChildServices?.includes('applyPPM'))){
                    ppmInformation.ppmList.push('childServices');
                }
        }
        return ppmInformation;
    }
 
}

